import { render, staticRenderFns } from "./Particular.vue?vue&type=template&id=41278566&"
import script from "./Particular.vue?vue&type=script&lang=js&"
export * from "./Particular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports